var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.375C15.5781 9.375 10.375 14.625 10.375 21C10.375 27.4219 15.5781 32.625 22 32.625C28.375 32.625 33.625 27.4219 33.625 21C33.625 14.625 28.375 9.375 22 9.375ZM27.3438 17.2969C27.2031 19.125 26.4531 23.625 26.0312 25.6406C25.8906 26.5312 25.5625 26.8125 25.2344 26.8594C24.5781 26.9062 24.0625 26.3906 23.4062 25.9688C22.375 25.3125 21.8125 24.8906 20.8281 24.2344C19.6562 23.4844 20.4062 23.0625 21.0625 22.4062C21.25 22.2188 24.2031 19.5 24.25 19.2656C24.2969 19.2188 24.2969 19.125 24.2031 19.0312C24.1562 18.9844 24.0625 19.0312 23.9688 19.0312C23.875 19.0312 22.2344 20.1094 19.0938 22.2656C18.625 22.5938 18.2031 22.7344 17.8281 22.7344C17.4062 22.7344 16.6094 22.5 16 22.3125C15.2969 22.0781 14.6875 21.9375 14.7344 21.5625C14.7812 21.3281 15.0625 21.1406 15.625 20.9062C19 19.4062 21.25 18.4688 22.375 18C25.6094 16.6406 26.3125 16.4062 26.7344 16.4062C26.8281 16.4062 27.0625 16.4062 27.2031 16.5469C27.25 16.5938 27.3438 16.7344 27.3438 16.8281C27.3906 17.0156 27.3906 17.1562 27.3438 17.2969Z",
    fill: "#45B549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/TelegramIcon.465dd77ebd256c31048598d7a7f8cb6e.svg";
export { ForwardRef as ReactComponent };